import { MAIN_MENU_REPORT_KEY_PERMISSION } from './app_main_menu_permission_keys';
import {
  ACCOUNTS_RECEIVABLE_SALES_JOURNAL,
  AGENCY_PERFERMANCE_OVERVIEW,
  ARRIVAL,
  CASH_REGISTER,
  CASHIER,
  DAILY_FORECAST,
  DAILY_REPORT,
  DEPARTURE,
  FINANCIAL,
  FINANCIAL_ACCOUNT,
  FLASH_MANAGER,
  FORECAST_BY_ROOM_TYPE,
  FOUR_WEEK_FORECAST,
  FRONT_DESK,
  HOUSE_KEEPING,
  IN_HOUSE,
  LOGS,
  NATIONALITY_FORECAST,
  NIGHT_AUDIT,
  PRE_PAYMENT,
  ROOM_MOVE,
  RESERVATION,
  RESERVATION_LIST,
  ROOM_STATE,
  TRANSACTIONS_LIST,
  TRIAL_BALANCE,
} from './app_permissions';

/***************************** MENU_RESERVATION *****************************/
export const MENU_REPORT_RESERVATION_KEY_PERMISSION = `${MAIN_MENU_REPORT_KEY_PERMISSION}.${RESERVATION}`;
/**/ export const MENU_REPORT_DAILY_FORECAST_KEY_PERMISSION = `${MENU_REPORT_RESERVATION_KEY_PERMISSION}.${DAILY_FORECAST}`;
/**/ export const MENU_REPORT_FORECAST_BY_ROOM_TYPE_KEY_PERMISSION = `${MENU_REPORT_RESERVATION_KEY_PERMISSION}.${FORECAST_BY_ROOM_TYPE}`;
/**/ export const MENU_REPORT_FOUR_WEEK_FORECAST_KEY_PERMISSION = `${MENU_REPORT_RESERVATION_KEY_PERMISSION}.${FOUR_WEEK_FORECAST}`;
/**/ export const MENU_REPORT_RESERVATION_LIST_KEY_PERMISSION = `${MENU_REPORT_RESERVATION_KEY_PERMISSION}.${RESERVATION_LIST}`;

/**/ export const MENU_REPORT_NATIONALITY_FORECAST_KEY_PERMISSION = `${MENU_REPORT_RESERVATION_KEY_PERMISSION}.${NATIONALITY_FORECAST}`;

/***************************** MENU_FRONT_DESK *****************************/
export const MENU_REPORT_FRONT_DESK_KEY_PERMISSION = `${MAIN_MENU_REPORT_KEY_PERMISSION}.${FRONT_DESK}`;
/**/ export const MENU_REPORT_ARRIVAL_KEY_PERMISSION = `${MENU_REPORT_FRONT_DESK_KEY_PERMISSION}.${ARRIVAL}`;
/**/ export const MENU_REPORT_DEPARTURE_KEY_PERMISSION = `${MENU_REPORT_FRONT_DESK_KEY_PERMISSION}.${DEPARTURE}`;
/**/ export const MENU_REPORT_IN_HOUSE_KEY_PERMISSION = `${MENU_REPORT_FRONT_DESK_KEY_PERMISSION}.${IN_HOUSE}`;
/**/ export const MENU_REPORT_DAILY_REPORT_KEY_PERMISSION = `${MENU_REPORT_FRONT_DESK_KEY_PERMISSION}.${DAILY_REPORT}`;
/**/ export const MENU_REPORT_LOGS_KEY_PERMISSION = `${MENU_REPORT_FRONT_DESK_KEY_PERMISSION}.${LOGS}`;
/**/ export const MENU_REPORT_ROOM_MOVE_KEY_PERMISSION = `${MENU_REPORT_FRONT_DESK_KEY_PERMISSION}.${ROOM_MOVE}`;
/**/ export const MENU_REPORT_ROOM_STATE_KEY_PERMISSION = `${MENU_REPORT_FRONT_DESK_KEY_PERMISSION}.${ROOM_STATE}`;

/***************************** MENU_CASHIER *****************************/
export const MENU_REPORT_CASHIER_KEY_PERMISSION = `${MAIN_MENU_REPORT_KEY_PERMISSION}.${CASHIER}`;
/**/ export const MENU_REPORT_CASH_REGISTER_KEY_PERMISSION = `${MENU_REPORT_CASHIER_KEY_PERMISSION}.${CASH_REGISTER}`;
/**/ export const MENU_REPORT_TRANSACTIONS_LIST_KEY_PERMISSION = `${MENU_REPORT_CASHIER_KEY_PERMISSION}.${TRANSACTIONS_LIST}`;
/**/ export const MENU_REPORT_PRE_PAYMENT_KEY_PERMISSION = `${MENU_REPORT_CASHIER_KEY_PERMISSION}.${PRE_PAYMENT}`;

/***************************** MENU_HOUSE_KEEPING *****************************/
export const MENU_REPORT_HOUSE_KEEPING_KEY_PERMISSION = `${MAIN_MENU_REPORT_KEY_PERMISSION}.${HOUSE_KEEPING}`;

/***************************** MENU_FINANCIAL *****************************/
export const MENU_REPORT_FINANCIAL_KEY_PERMISSION = `${MAIN_MENU_REPORT_KEY_PERMISSION}.${FINANCIAL}`;
/**/ export const MENU_REPORT_ACCOUNTS_RECEIVABLE_SALES_JOURNAL_KEY_PERMISSION = `${MENU_REPORT_FINANCIAL_KEY_PERMISSION}.${ACCOUNTS_RECEIVABLE_SALES_JOURNAL}`;
/**/ export const MENU_REPORT_FLASH_MANAGER_KEY_PERMISSION = `${MENU_REPORT_FINANCIAL_KEY_PERMISSION}.${FLASH_MANAGER}`;
/**/ export const MENU_REPORT_TRIAL_BALANCE_KEY_PERMISSION = `${MENU_REPORT_FINANCIAL_KEY_PERMISSION}.${TRIAL_BALANCE}`;
/**/ export const MENU_REPORT_AGENCY_PERFERMANCE_OVERVIEW_KEY_PERMISSION = `${MENU_REPORT_FINANCIAL_KEY_PERMISSION}.${AGENCY_PERFERMANCE_OVERVIEW}`;
/**/ export const MENU_REPORT_FINANCIAL_ACCOUNT_KEY_PERMISSION = `${MENU_REPORT_FINANCIAL_KEY_PERMISSION}.${FINANCIAL_ACCOUNT}`;

/***************************** MENU_NIGHT_AUDIT *****************************/
export const MENU_REPORT_NIGHT_AUDIT_KEY_PERMISSION = `${MAIN_MENU_REPORT_KEY_PERMISSION}.${NIGHT_AUDIT}`;
